module.exports = __webpack_public_path__ + "static/media/receive-results.227fc1f0.svg";